import type { Employee, RoleSegment } from '../types/hr';

export type WorkGroup = 'Operations' | 'Sales';

export const WORK_GROUPS: WorkGroup[] = ['Operations', 'Sales'];

export const TEAMS_BY_GROUP: Record<WorkGroup, string[]> = {
  Operations: ['Loan Operations', 'Funding & Post-Closing', 'QC & Documents', 'Ops Leadership'],
  Sales: ['Retail Sales', 'Wholesale', 'Sales Support', 'Sales Leadership'],
};

export function groupFor(e: Employee): WorkGroup | null {
  if (e.department === 'Operations') return 'Operations';
  if (e.department === 'Sales') return 'Sales';
  return null;
}

export function teamFor(e: Employee): string {
  const t = e.jobTitle;
  if (e.department === 'Operations') {
    if (/VP|Manager|Team Lead/.test(t)) return 'Ops Leadership';
    if (/Funding|Shipping|Post-Closing/.test(t)) return 'Funding & Post-Closing';
    if (/Quality|Document/.test(t)) return 'QC & Documents';
    return 'Loan Operations';
  }
  if (e.department === 'Sales') {
    if (/Director/.test(t)) return 'Sales Leadership';
    if (e.division === 'Wholesale') return 'Wholesale';
    if (/Assistant/.test(t)) return 'Sales Support';
    return 'Retail Sales';
  }
  return e.department;
}

export function isLoanOfficer(e: Employee): boolean {
  return /Loan Officer/.test(e.jobTitle) && !/Assistant/.test(e.jobTitle);
}

/** NMLS-licensed originators (demo rule): Sales staff who originate loans. */
export function isLicensed(e: Employee): boolean {
  return e.department === 'Sales' && /Loan Officer|Account Executive|Director of Sales/.test(e.jobTitle) && !/Assistant/.test(e.jobTitle);
}

export const ROLE_SEGMENTS: { id: RoleSegment; label: string; description: string; test: (e: Employee) => boolean }[] = [
  { id: 'loan-officers', label: 'Loan Officers', description: 'Originating loan officers', test: isLoanOfficer },
  { id: 'operations', label: 'Operations', description: 'Operations department', test: (e) => e.department === 'Operations' },
  { id: 'sales', label: 'Sales', description: 'Sales department', test: (e) => e.department === 'Sales' },
  { id: 'licensed', label: 'Licensed (NMLS)', description: 'Staff with an NMLS license', test: isLicensed },
];

export function segmentById(id?: RoleSegment) {
  return ROLE_SEGMENTS.find((s) => s.id === id);
}
